import {z} from '@hono/zod-openapi';

export const supportTrainingResponseSchema = z
  .object({
    messageId: z.string().openapi({example: 'a1b2c3d4-...'}),
  })
  .openapi('SupportTrainingResponse');

export type SupportTrainingResponse = z.infer<typeof supportTrainingResponseSchema>;
